import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import useAsync from "../hooks/useAsync";
import WithdrawServices from "../services/WithdrawServices";
import ViewWithdraw from "./View Model/ViewWithdraw";
import WithdrawUpdate from "./Update Model/UpdateWithdraw";
import WithdrawStatus from "./TogelButton/WithdrawStatus"
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import Pagetitle from "./PageTitle";
import * as XLSX from "xlsx";

Modal.setAppElement("#root");

const Withdraw = () => {
  const { data, run } = useAsync(WithdrawServices.getAllWithdraw);
  // console.log(data)
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");

  const withdrawPerPage = 10;

  const handleEditDetails = (withdraw) => {
    setSelectedEdit(withdraw);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const handleViewDetails = (withdraw) => {
    setSelectedUser(withdraw);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = ({ selected }) => setCurrentPage(selected + 1);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date) ? "Invalid Date" : date.toLocaleDateString("en-GB").split("/").join("-");
  };
  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };
  const filteredWithdraws = (data?.data || []).filter((withdraw) => {
    const matchesSearch = searchQuery
      ? withdraw?.investor?.name?.toLowerCase().includes(searchQuery.toLowerCase())
      : true;
    const matchesDate = dateFilter
      ? formatDate(withdraw?.createdAt) === formatDate(dateFilter)
      : true;
      const matchesStatus = statusFilter
      ? withdraw?.status?.toLowerCase() === statusFilter?.toLowerCase()
      : true;
    return matchesSearch && matchesDate && matchesStatus;
  });

  const generateExcel = () => {
    const exportData = filteredWithdraws.map((withdraw,index) => ({
      Sno : index+1,
      InvestorName: withdraw?.investor?.name || "N/A",
      RemainingAmount: withdraw?.remainingAmount || "N/A",
      requestAmount: withdraw?.requestAmount || "N/A",
      WithdrawAmount: withdraw?.amount || "N/A",
      WithdrawalStatus: withdraw?.status || "N/A",
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Withdraw");
    XLSX.writeFile(wb, "withdraw_data.xlsx");
  };

  const indexOfLastUser = currentPage * withdrawPerPage;
  const indexOfFirstUser = indexOfLastUser - withdrawPerPage;
  const paginatedWithdraws = filteredWithdraws.slice(indexOfFirstUser, indexOfLastUser);

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search Investor"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
          <div className="sub-title-box-right d-flex">
            <select style={{ backgroundColor: "#fff" }}     value={statusFilter}
                onChange={handleStatusChange}>
              <option value="">Withdrawal Status</option>
              <option value="Pending" style={{ color: "#F9B842" }}>Pending</option>
              <option value="Approved" style={{ color: "#699836" }}>Approved</option>
              <option value="Reject" style={{ color: "#FF3333" }}>Reject</option>
            </select>
            <input
              type="date"
              className="ms-3"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            />
            <button className="excel-btn site-btn-green ms-3" onClick={generateExcel}>
              <img src="img/excel-btn.svg" alt="" />
              <span className="ms-2">Download</span>
            </button>
          </div>
        </div>
        <div className="container-box-inner">
          <table className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Request Date</th>
                <th>Investor Name</th>
                <th>Amount Requested</th>
                <th>Remaining Amount</th>
                <th>Withdrawal Status</th>
                <th>Payment Method</th>
                <th>Add Payment</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedWithdraws.map((withdraw, index) => (
                <tr key={withdraw?._id}>
                  <td>{index + 1 + (currentPage - 1) * withdrawPerPage}</td>
                  <td>{formatDate(withdraw?.createdAt)}</td>
                  <td>{withdraw?.investor?.name || "N/A"}</td>
                  <td>{withdraw?.requestAmount || "N/A"}</td>
                  <td>{withdraw?.remainingAmount || "N/A"}</td>
                  <td className="status-toggle">
                    <WithdrawStatus data={withdraw} page="Withdraw" onSuccess={run} />
                  </td>
                  <td>{withdraw?.paymentMethod || "N/A"}</td>
                  <td>
                    <button className="add-btn" onClick={() => handleEditDetails(withdraw)}>+ Add</button>
                  </td>
                  <td>
                    <button className="edit trans-btn" onClick={() => handleViewDetails(withdraw)}>
                      <img src="img/view-btn.svg" alt="View" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredWithdraws?.length || 0) / withdrawPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            pageClassName={"page-item"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            disabledClassName={"disabled"}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewWithdraw withdraw={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <WithdrawUpdate withdraw={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
    </div>
  );
};

export default Withdraw;